<script setup lang="ts">
import PageMeta from "../../components/PageMeta";
</script>

<!--
  TODO: complete all content once the audit will be done.
 -->
<template>
  <PageMeta
    title="Accessibilité"
    description="Déclaration d’accessibilité du site aram.aplusb.pro"
  />
  <section class="fr-my-0 fr-mx-auto content">
    <h1>Déclaration d’accessibilité</h1>
    <p>
      AplusB
      s’engage à rendre ses sites internet, intranet, extranet et ses progiciels
      accessibles (et ses applications mobiles et mobilier urbain numérique)
      conformément à l’article 47 de la loi n°2005-102 du 11 février 2005.
    </p>
    <p>
      Cette déclaration d’accessibilité s’applique à
      <strong>aram.aplusb.pro</strong>.
    </p>

    <h2 id="etat-conformite">État de conformité</h2>

    <p>
      Aucun audit n’a été encore effectué.<br />
      Aram.aplusb.pro est non conforme avec le référentiel général
      d’amélioration de l’accessibilité (RGAA).
    </p>
    <p>
      Un audit de conformité est planifié par la DINUM sur l'outil Ara, dont Aram est un service dérivé. Aram sera mis
      à jour en conséquence.
    </p>

    <h2 id="contact">Retour d’information et contact</h2>
    <p>
      Si vous n’arrivez pas à accéder à un contenu ou à un service, vous pouvez
      nous contacter par courriel à l’adresse
      <strong>contact@aplusb.pro</strong> pour être orienté vers
      une alternative accessible ou obtenir le contenu sous une autre forme.
    </p>
  </section>
</template>

<style scoped>
.content {
  max-width: 49.5rem;
}
</style>
